export const ColumnVisibilityIcon = () => {
  return (
    <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.25 13.5C13.25 13.8978 13.408 14.2794 13.6893 14.5607C13.9706 14.842 14.3522 15 14.75 15C15.1478 15 15.5294 14.842 15.8107 14.5607C16.092 14.2794 16.25 13.8978 16.25 13.5C16.25 13.1022 16.092 12.7206 15.8107 12.4393C15.5294 12.158 15.1478 12 14.75 12C14.3522 12 13.9706 12.158 13.6893 12.4393C13.408 12.7206 13.25 13.1022 13.25 13.5Z"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.5 13.4999C19.7 16.4999 17.45 17.9999 14.75 17.9999C12.05 17.9999 9.8 16.4999 8 13.4999C9.8 10.4999 12.05 8.99988 14.75 8.99988C17.45 8.99988 19.7 10.4999 21.5 13.4999Z"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <mask
        id="mask0_612_3392"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="19"
        height="15"
      >
        <path d="M19 7.94118L11.5 7.5L6.82051 12.877V15H0V0H19V7.94118Z" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_612_3392)">
        <path
          d="M3.46875 0.578125H15.0312C16.6277 0.578125 17.9219 1.8723 17.9219 3.46875V11.3311C17.9219 12.9275 16.6277 14.2217 15.0312 14.2217H3.46875C1.8723 14.2217 0.578125 12.9275 0.578125 11.3311V3.46875C0.578127 1.8723 1.8723 0.578125 3.46875 0.578125Z"
          stroke="white"
          strokeWidth="1.2"
        />
        <line
          x1="4.04688"
          y1="11.3313"
          x2="14.4531"
          y2="11.3313"
          stroke="white"
          strokeWidth="1.2"
          strokeLinecap="round"
        />
        <path
          d="M6.9375 6.12817L8.77576 8.33408C8.82198 8.38956 8.90718 8.38956 8.95341 8.33408L12.7188 3.81567"
          stroke="white"
          strokeWidth="1.2"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
};

export const ColumnPinIcon = () => {
  return (
    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.27402 0.822632L4.69339 3.40326L2.11276 4.371L1.14502 5.33874L5.66113 9.85485L6.62886 8.88711L7.5966 6.30648L10.1772 3.72584"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.40321 7.5968L0.5 10.5"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.95166 0.5L10.5 4.04837"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
